export enum AceInvolvementVisibilityEnum {
  FULL = 'Full',
  LIMITED = 'Limited',
}
